import React from "react"

export const QuestionMarkIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 7.67969C5.15625 7.67969 4.89844 7.95898 4.89844 8.28125C4.89844 8.625 5.15625 8.88281 5.5 8.88281C5.82227 8.88281 6.10156 8.625 6.10156 8.28125C6.10156 7.95898 5.82227 7.67969 5.5 7.67969ZM5.65039 7.16406C5.80078 7.16406 5.9082 7.05664 5.9082 6.90625C5.9082 5.98242 7.58398 6.04688 7.58398 4.60742C7.58398 3.51172 6.5957 2.86719 5.47852 2.86719C4.51172 2.86719 3.97461 3.25391 3.52344 3.83398C3.4375 3.96289 3.45898 4.11328 3.58789 4.19922L3.86719 4.41406C3.97461 4.47852 4.125 4.45703 4.21094 4.34961C4.5332 3.94141 4.85547 3.72656 5.47852 3.72656C6.33789 3.72656 6.72461 4.17773 6.72461 4.60742C6.72461 5.53125 5.04883 5.40234 5.04883 6.90625C5.04883 7.05664 5.17773 7.16406 5.30664 7.16406H5.65039ZM5.5 1.23438C8.03516 1.23438 10.1406 3.31836 10.1406 5.875C10.1406 8.45312 8.05664 10.5156 5.5 10.5156C2.92188 10.5156 0.859375 8.45312 0.859375 5.875C0.859375 3.31836 2.92188 1.23438 5.5 1.23438ZM5.5 0.546875C2.55664 0.546875 0.171875 2.95312 0.171875 5.875C0.171875 8.81836 2.55664 11.2031 5.5 11.2031C8.42188 11.2031 10.8281 8.81836 10.8281 5.875C10.8281 2.95312 8.42188 0.546875 5.5 0.546875Z" />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/QuestionMarkIcon.js